// src/api/faqApi.js
import apiClient from './apiClient';

const faqClient = apiClient('');

const faqApi = {
    /**
     * Получить все активные FAQ (публичный эндпоинт)
     * GET /faqs
     */
    async getFaqs() {
        const res = await faqClient.get('/faqs');
        return res.data;
    },

    /**
     * Получить FAQ по ID
     * GET /faqs/:id
     */
    async getFaqById(id) {
        const res = await faqClient.get(`/faqs/${id}`);
        return res.data;
    },

    /**
     * Получить все FAQ включая неактивные (требует роль ADMIN или SUPPORT)
     * GET /faqs/all
     */
    async getAllFaqs() {
        const res = await faqClient.get('/faqs/all');
        return res.data;
    },

    /**
     * Создать новый FAQ (требует роль ADMIN)
     * POST /faqs
     */
    async createFaq(data) {
        const res = await faqClient.post('/faqs', data);
        return res.data;
    },

    /**
     * Обновить FAQ (требует роль ADMIN)
     * PUT /faqs/:id
     */
    async updateFaq(id, data) {
        const res = await faqClient.put(`/faqs/${id}`, data);
        return res.data;
    },

    /**
     * Удалить FAQ (требует роль ADMIN)
     * DELETE /faqs/:id
     */
    async deleteFaq(id) {
        const res = await faqClient.delete(`/faqs/${id}`);
        return res.data;
    },
};

export default faqApi;
